/// <amd-module name="Feed/Legacy/Actions/FeedSettings/RestoreFeedHandler" />
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

import { getFeedClient, IFeedRestClient } from "Feed/Common/RestClient/Feed";
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";

/**
 * User clicked on Restore feed button in Restore Feed Dialog
 */
export class RestoreFeedHandler {
    public static async handleAsync(state: IFeedSettingsState): Promise<void> {
        const feed = state.feed();
        const projectId = feed.project ? feed.project.id : null;
        const feedClient: IFeedRestClient = getFeedClient(state.pageContext);
        const request = <VS_Services.JsonPatchDocument>[
            {
                from: null,
                path: "/isDeleted",
                op: VS_Services.Operation.Replace,
                value: false
            }
        ];
        await feedClient.restoreDeletedFeed(request, feed.id, projectId);
        return;
    }
}
